import { useState, useEffect, useRef } from 'react'
import { motion } from 'framer-motion'
import { Play, Pause, Square, RotateCcw } from 'lucide-react'
import Button from './Button'

const SessionTimer = ({ onDurationChange, initialDuration = 0 }) => {
  const [isRunning, setIsRunning] = useState(false)
  const [duration, setDuration] = useState(initialDuration)
  const [startTime, setStartTime] = useState(null)
  const intervalRef = useRef(null)

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        setDuration((prev) => {
          const newDuration = prev + 1
          if (onDurationChange) {
            onDurationChange(newDuration)
          }
          return newDuration
        })
      }, 1000)
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [isRunning, onDurationChange])

  const handleStart = () => {
    setIsRunning(true)
    setStartTime(Date.now())
  }

  const handlePause = () => {
    setIsRunning(false)
  }

  const handleReset = () => {
    setIsRunning(false)
    setDuration(0)
    setStartTime(null)
    if (onDurationChange) {
      onDurationChange(0)
    }
  }

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600)
    const mins = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60
    if (hrs > 0) {
      return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    }
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
  }

  return (
    <div className="flex items-center gap-4">
      <motion.div
        className="text-4xl font-bold text-gray-900 font-mono"
        animate={isRunning ? { scale: [1, 1.05, 1] } : {}}
        transition={{ duration: 2, repeat: isRunning ? Infinity : 0 }}
      >
        {formatTime(duration)}
      </motion.div>
      <div className="flex items-center gap-2">
        {!isRunning ? (
          <Button
            onClick={handleStart}
            className="flex items-center gap-2"
            size="sm"
          >
            <Play size={18} />
            Start
          </Button>
        ) : (
          <Button
            onClick={handlePause}
            variant="secondary"
            className="flex items-center gap-2"
            size="sm"
          >
            <Pause size={18} />
            Pause
          </Button>
        )}
        <Button
          onClick={handleReset}
          variant="secondary"
          className="flex items-center gap-2"
          size="sm"
        >
          <RotateCcw size={18} />
          Reset
        </Button>
      </div>
    </div>
  )
}

export default SessionTimer

